export const WAITLIST_URL = "https://forms.gle/6DJPMg4cmGi146CA6";
export const CTA_TEXT = "Signup on the Waitlist";
